import {FC, ReactNode} from "react";
import ImageElement from "@/components/content/Image/Image";
import Link from "next/link";
import SVGIcon from "@/components/SVG";
// import {ChevronLeftIcon, ChevronRightIcon} from "@heroicons/react/solid";

interface PageHeaderProps {
  title: string
  background?: string
  backgroundImage?: string
  backgroundImageAlt?: string
}

const PageHeader: FC<PageHeaderProps> = ({
  title,
  background,
  backgroundImage,
  backgroundImageAlt
}) => {

  return (
    <div className="relative">

      <div className="absolute inset-0">
        <>
        {/*<ImageElement*/}
        {/*  imageProperties={{*/}
        {/*    alt: 'dr allen wan',*/}
        {/*    height: 160,*/}
        {/*    layout: "fill",*/}
        {/*    objectFit: 'cover',*/}
        {/*    // src: '/static/images/team/dr-allen-wan.png',*/}
        {/*    src: 'https://images.unsplash.com/photo-1525130413817-d45c1d127c42?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1920&q=60&&sat=-100',*/}
        {/*    width: 1730,*/}
        {/*  }}*/}
        {/*  imageClasses={{*/}
        {/*    width: 'w-full',*/}
        {/*    height: 'h-full',*/}
        {/*    objectFit: 'object-contain'*/}
        {/*  }}*/}
        {/*/>*/}
        </>
        <div className={`absolute inset-0 ${background} mix-blend-multiply opacity-95`} aria-hidden="true" />
      </div>

      <div className="relative max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-12 flex flex-row flex-wrap items-center">
        {/* Breadcrumb Container */}
        <div className="basis-full">
          {/* Hidden Back Button */}
          {/*<nav className="sm:hidden" aria-label="Back">*/}
          {/*  <Link href="#">*/}
          {/*    <a className="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700">*/}
          {/*      /!*<ChevronLeftIcon className="flex-shrink-0 -ml-1 mr-1 h-5 w-5 text-gray-400" aria-hidden="true"/>*!/*/}
          {/*      Back*/}
          {/*    </a>*/}
          {/*  </Link>*/}
          {/*</nav>*/}
          {/* Breadcrumbs */}
          <nav className="hidden sm:flex" aria-label="Breadcrumb">
            <ol role="list" className="flex items-center space-x-4">
              <li>
                <div className="flex">
                  <Link href="/" >
                    <a className="text-sm font-medium text-white hover:text-[#ff6600]">
                      Home
                    </a>
                  </Link>
                </div>
              </li>
              <li>
                <div className="flex items-center">
                  <SVGIcon
                    name={"heroiconsCaretRight"}
                    fill="#fff"
                    stroke="#fff"
                    viewBox="0 0 24 24"
                    className={"h-7 w-7"}
                  />
                  {/*<ChevronRightIcon className="flex-shrink-0 h-5 w-5 text-white" aria-hidden="true"/>*/}
                    <a aria-current="page"
                       className="ml-4 text-sm font-medium text-white no-underline">
                      {title}
                    </a>
                </div>
              </li>
            </ol>
          </nav>
        </div>
        {/* Page Title */}
        <h1 className="basis-1/2 font-extrabold tracking-tight text-[#ff6600] text-2xl sm:text-4xl">
          {title}
        </h1>
        {/* Page Banner Image Overlay */}
        {backgroundImage ? (
          <div
            className="basis-1/2"
          >
            <img
              src={backgroundImage}
              alt={backgroundImageAlt}
              className="w-full h-full object-cover"
            />
          </div>
        ) : null}
      </div>

    </div>
  )
}

export default PageHeader;
